import './index.css'

const TabItem = props => {
  const {details, onClickTab, isActive} = props

  const {tabId, displayText} = details

  const onClickx = () => {
    onClickTab(tabId)
  }

  const tT = isActive ? 'active-tab-text' : 'tab-text'

  return (
    <li>
      <button className="tab-button" type="button" onClick={onClickx}>
        <p className={tT}>{displayText}</p>
      </button>
    </li>
  )
}

export default TabItem
